import {
  IProviderPayoutRequest,
  IProviderPayoutResponse,
  ITotalPatientPortionResponse,
  ITopCaseRatesResponse,
  ITopCaseRatesRequest,
} from "types/ProviderPayout";

import { api } from ".";

const providerProcedureQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getTotalAllowableAndPatientPortion: builder.query<
      IProviderPayoutResponse,
      IProviderPayoutRequest
    >({
      query: (params) => ({
        url: `provider-payouts/analytics/total-allowable-patient-portion`,
        params,
      }),
    }),
    getTotalPatientPortionByOrderId: builder.query<
      ITotalPatientPortionResponse,
      { orderId: string }
    >({
      query: ({ orderId }) => ({
        url: `provider-payouts/order/${orderId}/total-patient-portion`,
      }),
    }),
    getTopCaseRatesWithPayers: builder.query<
      ITopCaseRatesResponse,
      ITopCaseRatesRequest
    >({
      query: (params) => ({
        url: `provider-payouts/analytics/top-case-rates-with-payers`,
        params,
      }),
    }),
  }),
});

export const {
  useGetTotalAllowableAndPatientPortionQuery,
  useGetTotalPatientPortionByOrderIdQuery,
  useGetTopCaseRatesWithPayersQuery,
} = providerProcedureQueries;
